import UserRoleCapabilitiesService from './service';
import type { GetUserRoleCapabilitiesQueryData } from './types';

export const USER_ROLE_CAPABILITIES_QUERY_KEYS = {
  GET_USER_ROLE_CAPABILITIES: 'GET_USER_ROLE_CAPABILITIES',
};

export class UserRoleCapabilitiesQueries {
  public static readonly getUserRoleCapabilities = async (): Promise<GetUserRoleCapabilitiesQueryData> => {
    const { data } = await UserRoleCapabilitiesService.getUserRoleCapabilities();
    return data;
  };
}
